import { useLang } from '@/app/utils/useLang';
import styles from './index.module.scss';
import Marquee from './Marquee';

const partnerLogos = [
    {
        name: 'ncda',
        src: 'https://websiteoss.ecoflow.com/upload/image/1753859993644/1-WRN%20Ambassador%20logo%201.png',
        link: 'https://www.weather.gov/about/wrn-ambassadors',
    },
    { name: 'wprn', src: 'https://websiteoss.ecoflow.com/upload/image/1753859993310/2-Red%20Ligntning%20logo%201.png', link: 'https://www.red-lightning.com/' },
    { name: 'red-lightning', src: 'https://websiteoss.ecoflow.com/upload/image/1753859991749/Group%204.png', link: 'https://www.sjacymru.org.uk/' },
    {
        name: 'st-john',
        src: 'https://websiteoss.ecoflow.com/upload/image/1753859519645/4-Social%20Emergency%20Management%20Alliance%20logo.jpg',
        link: 'https://sema.yahoo.co.jp/?utm_source=chatgpt.com',
    },
    {
        name: 'sema',
        src: 'https://websiteoss.ecoflow.com/upload/image/1753859519923/5-%E8%93%9D%E5%A4%A9%E6%95%91%E6%8F%B4.jpg',
        link: 'https://www.bsr.foundation',
    },
    { name: 'bsr', src: 'https://websiteoss.ecoflow.com/upload/image/1753859991575/%F0%9F%9B%A0-Blocks.png', link: 'https://convoyofhope.org/' },
    {
        name: 'convoy-of-hope',
        src: 'https://websiteoss.ecoflow.com/upload/image/1753859992276/7-Footprint%20Project%20logo%201.png',
        link: 'https://www.footprintproject.org/home',
    },
    {
        name: 'footprint-project',
        src: 'https://websiteoss.ecoflow.com/upload/image/1753859991906/8-Special%20Forces%20Charitable%20Trust%20logo%201.png',
        link: 'https://deoppressoliber.com/charities/',
    },
];

const LogoItem = ({ logo }: { logo: { name: string; src: string; link: string } }) => (
    <div
        className="logo-item"
        onClick={() => {
            if (logo.link) {
                window.open(logo.link, '_blank');
            }
        }}
    >
        <img src={logo.src} alt={logo.name} />
    </div>
);

export default function Partner() {
    const { t } = useLang('corporatesocialresponsibility');

    const firstRowLogos = partnerLogos.slice(0, 4);
    const secondRowLogos = partnerLogos.slice(4, 8);

    const pcItems = partnerLogos.map((logo) => <LogoItem key={logo.name} logo={logo} />);
    const padFirstRowItems = firstRowLogos.map((logo) => <LogoItem key={logo.name} logo={logo} />);
    const padSecondRowItems = secondRowLogos.map((logo) => <LogoItem key={logo.name} logo={logo} />);

    return (
        <div className={`${styles.Partner} GtmModuleData-section`}>
            <div className="partner-container">
                <div className="powerforall-header pfa-layout">
                    <h2 className="title">{t('secH_title')}</h2>
                    <p className="desc">{t('secH_desc')}</p>
                </div>

                <div className="marquee-wrapper pc-marquee">
                    <Marquee items={pcItems} direction="left" gap={24} />
                </div>

                <div className="marquee-wrapper pad-marquee">
                    <Marquee items={padFirstRowItems} direction="left" gap={6} />
                    <Marquee items={padSecondRowItems} direction="right" gap={6} />
                </div>
            </div>
        </div>
    );
}
